'use strict';

module.exports = {
  src: 'about:blank',
  frameBorder: 0,
  allowtransparency: true,
  scrolling: 'no'
};



//////////////////
// WEBPACK FOOTER
// ./~/@braintree/iframer/lib/default-attributes.js
// module id = 656
// module chunks = 0